/* GroupingColumnRenderer.js */

"use strict";

const _ = require("lodash");
const BLANK_PLACEHOLDER = "Blank";

class GroupingColumnRenderer {
    constructor(model) {
        this._model = model;
        this._rootElem = this._createRootElem();
        this._rootElem.component = this._model;

        this._toggleBtn = this._createToggleBtn();
        this._titleContainer = this._createTitleContainer();
        this._countContainer = this._createCountContainer();

        if (this._model._isGroupHeader) {
            this.render().catch(
                console.error.bind(console, "GroupingColumnRenderer render error:")
            );
            this._registerListeners();
        }
    }

    get rootElement() {
        return this.getRootElement();
    }

    /********************************************/
    /* START PRIVATE COMPONENT RENDERER METHODS */
    /********************************************/

    _registerListeners() {
        this._model.on("Value", (this._onValue = this._onValue.bind(this)));
        this._rootElem.addEventListener(
            "click",
            (this._onDebouncedUserToggle = _.debounce(this._onUserToggle.bind(this), 500, false))
        );
        // Removing to make the whole grouping header clickable
        // this._toggleBtn.addEventListener("click", (this._onUserToggle = this._onUserToggle.bind(this)));
        // this._titleContainer.addEventListener("click", (this._onUserToggle = this._onUserToggle.bind(this)));
    }

    _unregisterListeners() {
        this._model.removeListener("Value", this._onValue);
        this._rootElem.removeEventListener("click", this._onDebouncedUserToggle);
        // this._toggleBtn.removeEventListener("click", this._onUserToggle);
        // this._titleContainer.removeEventListener("click", this._onUserToggle);
    }

    _shutdown() {
        this._unregisterListeners();
        return Promise.resolve().then(() => {
            this._model = undefined;
            this._rootElem.remove();
            this._rootElem = undefined;
        });
    }

    /*******************************************/
    /* END PRIVATE COMPONENT RENDERER METHODS  */
    /* START PUBLIC COMPONENT RENDERER METHODS */
    /*******************************************/
    /**
     * Stateless method to completely rebuild this component from the _rootElem down.
     * @returns {Promise} An ES6 promise that lets the caller know when the component has finished rendering. If a non
     * Promise is returned the caller will assume the Renderer has completed rendering.
     */
    render() {
        this._rootElem.innerHtml = "";
        let prom = Promise.resolve();

        const toggleWrapper = document.createElement("div");
        toggleWrapper.classList.add("toggle-wrapper");

        toggleWrapper.appendChild(this._toggleBtn);

        this._setTitle(this._model.getTitle());
        this._setCount(this._model._value);

        if (this._model._isGroupHeader) {
            prom = prom.then(() => {
                this._rootElem.appendChild(toggleWrapper);
                this._rootElem.appendChild(this._titleContainer);
                this._rootElem.appendChild(this._countContainer);
            });
        }
        return prom;
    }

    getRootElement() {
        return this._rootElem;
    }

    getModel() {
        return this._model;
    }

    /*******************************************/
    /* END COMPONENT RENDERER METHODS */
    /* START HANDLER METHODS */
    /*******************************************/
    /**
     * Fired when the value has been updated in the model
     * @param newVal {String}
     * @private
     */
    _onValue(newVal) {
        this._setCount(newVal);
    }

    _onUserToggle() {
        this._model.toggleGroup();
    }

    /*******************************************/
    /* END HANDLER METHODS */
    /* START PRIVATE API METHODS */
    /*******************************************/
    _setTitle(title) {
        title = _.escape(title || BLANK_PLACEHOLDER);

        if ((!title || title === "undefined") && this._model._replacementValue) {
            title = this._model._replacementValue;
        }

        if (title === "true" || title === "false") {
            title = _.capitalize(title);
        }

        this._titleContainer.innerHTML = title;
        this._titleContainer.setAttribute("title", title);
    }

    _setCount(count) {
        this._countContainer.innerHTML = count ? ` (${_.escape(count)})` : "";
    }

    _createRootElem() {
        const rootElem = document.createElement("div");
        rootElem.classList.add("group-field");
        return rootElem;
    }

    _createToggleBtn() {
        const collapseIcon = document.createElement("base-icon-gl");
        collapseIcon.dataset.icon = "common.chevron";
        return collapseIcon;
    }

    _createTitleContainer() {
        const titleContainer = document.createElement("div");
        titleContainer.classList.add("title");
        return titleContainer;
    }

    _createCountContainer() {
        const countContainer = document.createElement("div");
        countContainer.classList.add("count");
        return countContainer;
    }

    /*******************************************/
    /*  END PRIVATE API METHODS */
    /*******************************************/
}

module.exports = GroupingColumnRenderer;
